import { render } from "./SettingAds.vue?vue&type=template&id=3b19ecb3&scoped=true"
import script from "./SettingAds.vue?vue&type=script&lang=js"
export * from "./SettingAds.vue?vue&type=script&lang=js"

import "./SettingAds.vue?vue&type=style&index=0&id=3b19ecb3&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b19ecb3"]])

export default __exports__